import { allPageStyles } from './printStyles'; //Test

interface IErrorHandler {
  error: any;
  dispatch: any;
  setAlert: any;
  loadingType?: string;
}

interface IDownloadCSV {
  headers: any[];
  data: any[];
  fileName: string;
}

export const errorHandler = (data: IErrorHandler) => {
  const { error, dispatch, setAlert, loadingType } = data;
  console.log(error);
  if (error.response) {
    const data = error.response.data;
    if (data) {
      if (data.message) {
        dispatch(setAlert(data.message, 'error'));
      } else if (Array.isArray(data)) {
        data.forEach((m) => dispatch(setAlert(m, 'error')));
      }
    }
  } else if (error.message === undefined) {
    if (loadingType) {
      dispatch({ type: loadingType });
    }
  } else {
    console.log(error);
  }
};

export const generatePassword = () => {
  return Math.random().toString(36).substring(2, 10);
};

export const getDateString = (date: Date) => {
  return `${date.getFullYear()}-${('0' + String(date.getMonth() + 1)).slice(
    -2
  )}-${('0' + String(date.getDate())).slice(-2)}`;
};

export const getFirstDayString = (date: Date) => {
  const firstDay = new Date(date.setDate(1));
  return `${firstDay.getFullYear()}-${(
    '0' + String(firstDay.getMonth() + 1)
  ).slice(-2)}-${('0' + String(firstDay.getDate())).slice(-2)}`;
};

export const getLastDayString = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const lastDay = new Date(year, month, 0).getDate();
  return `${year}-${('0' + String(month)).slice(-2)}-${(
    '0' + String(lastDay)
  ).slice(-2)}`;
};

export const compareDates = (date1: Date, date2: Date) => {
  return (
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
};

export const getDaysAgo = (days: number) => {
  const today = new Date();
  return new Date(today.setDate(today.getDate() - days));
};

export const getFromToDate = (fromDate: Date, toDate: Date) => {
  const dates = {
    from: getDateString(fromDate),
    to: getDateString(toDate),
  };

  if (fromDate.getTime() > toDate.getTime()) {
    dates.from = getDateString(toDate);
    dates.to = getDateString(fromDate);
  }
  return dates;
};

export const downloadCSVfile = ({ headers, data, fileName }: IDownloadCSV) => {
  let rows = data;
  if (headers.length > 0) {
    rows = [headers, ...data];
  }

  const csvString = rows.map((e) => `"${e.join('","')}"`).join('\n');

  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const fileUrl = URL.createObjectURL(blob);
  link.setAttribute('href', fileUrl);
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadCSV = (headers: any[], data: any[], fileName: string) => {
  const sortedData: any[] = [];
  data.forEach((log) => {
    sortedData.push(
      headers.map((h) =>
        log[h.key] ? String(log[h.key]).replace(/"/g, '″') : ''
      )
    );
  });

  downloadCSVfile({
    headers: headers.map((h) => h.label),
    data: sortedData,
    fileName: `${fileName}_${new Date().getTime()}.csv`,
  });
};

export const downloadVerticalHeadersCSV = (
  headers: any[],
  data: any[],
  fileName: string
) => {
  const transposedData: any[][] = [];
  for (let i = 0; i < headers.length; i++) {
    transposedData.push([
      headers[i].label,
      ...data.map((row) => row[headers[i].key] ?? ''),
    ]);
  }

  downloadCSVfile({
    headers: [],
    data: transposedData,
    fileName: `${fileName}_${new Date().getTime()}.csv`,
  });
};

export const formGridRow = (headers: any[]) => {
  let row = '';
  headers.forEach((h, i) => {
    if (h.width) {
      row += i ? ` ${h.width}` : `${h.width}`;
    }
  });

  return row;
};

export const printComponent = (id: string, styles: string) => {
  const target = document.querySelector(`#${id}`);
  if (target) {
    const a = window.open('', '', 'height=600, width=1200');
    a?.document.write(
      `<html><body><div class="container">${target.innerHTML}</div></body></html>`
    );
    const mainCSS = document.createElement('style');
    mainCSS.innerHTML = `${allPageStyles} ${styles}`;
    a?.document.head.appendChild(mainCSS);
    a?.document.close();
    a?.print();
  }
};

export const roundNumber = (value: number, pow: number) => {
  if (pow === undefined) return value;
  const round = Math.pow(10, pow);
  return Math.round(value * round) / round;
};

export const getPreviousMonth = () => {
  const dates = {
    from: '',
    to: '',
  };

  let from = new Date();
  let to = new Date();
  from = new Date(from.setMonth(from.getMonth() - 1));
  dates.from = getDateString(new Date(from.setDate(1)));
  dates.to = getLastDayString(new Date(to.setMonth(to.getMonth() - 1)));

  return dates;
};

export const getFromToMonth = (fromDate: Date, toDate: Date) => {
  const dates = {
    from: getDateString(fromDate),
    to: getLastDayString(toDate),
  };

  if (fromDate.getTime() > toDate.getTime()) {
    dates.from = getDateString(toDate);
    dates.to = getLastDayString(fromDate);
  }
  return dates;
};
